"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentUserProfilePicture = exports.EMPTY_PICTURE = void 0;
exports.selectProfilePicture = selectProfilePicture;
exports.selectProfilePicturesMap = selectProfilePicturesMap;
var immutable_1 = require("immutable");
var toolkit_1 = require("@reduxjs/toolkit");
var index_1 = require("../../../../../config/index");
var state_types_1 = require("./state-types");
var config = (0, index_1.get)();
var communityProfileEnabled = !!(config && config.features
    && config.features.communityProfile);
exports.EMPTY_PICTURE = { url: '', small: '', card: '' };
// Cache .toJS() conversions keyed on the Immutable object itself.
// WeakMap allows GC to reclaim entries when the Immutable object is no longer referenced,
// preventing unbounded memory growth as users are viewed.
var _toJsCache = new WeakMap();
function toAvatar(gql) {
    var cached = _toJsCache.get(gql);
    if (cached)
        return cached;
    // .toJS() returns the wide JS union; the schema guarantees Avatar shape.
    var result = gql.toJS();
    _toJsCache.set(gql, result);
    return result;
}
/**
 * Select a profile picture for a given uid from the GraphQL lookup table.
 *
 * Feature-flag gated:
 *   ON  → returns { url, small, card } (empty strings if not yet loaded)
 *   OFF → returns null (callers use their existing REST paths)
 */
function selectProfilePicture(state, uid) {
    if (!communityProfileEnabled)
        return null;
    if (!uid)
        return exports.EMPTY_PICTURE;
    var gql = (0, state_types_1.selectProfilePictureForUid)(state, String(uid));
    if (gql && gql.size > 0)
        return toAvatar(gql);
    return exports.EMPTY_PICTURE;
}
/**
 * Memoized selector for the current user's profile picture.
 * Uses createSelector so the derived .toJS() object is referentially stable
 * across renders when the underlying Immutable data hasn't changed.
 */
exports.selectCurrentUserProfilePicture = (0, toolkit_1.createSelector)([state_types_1.selectAuthUid, state_types_1.selectProfilePicturesData], function (uid, data) {
    if (!communityProfileEnabled)
        return null;
    if (!uid)
        return exports.EMPTY_PICTURE;
    var value = data.get(String(uid));
    if ((0, state_types_1.isStringMap)(value) && value.size > 0)
        return toAvatar(value);
    return exports.EMPTY_PICTURE;
});
/**
 * Select the entire profilePictures lookup Map.
 *
 * Feature-flag gated:
 *   ON  → returns Immutable Map keyed by uid string
 *   OFF → returns empty Map (callers fall back to REST paths)
 */
function selectProfilePicturesMap(state) {
    if (!communityProfileEnabled)
        return (0, immutable_1.Map)();
    return (0, state_types_1.selectProfilePicturesData)(state);
}
